import { resolveURL } from "../utils/url.js";
async function fetchAccounts(baseURL) {
  const response = await fetch(resolveURL("/api/v4/accounts/", baseURL));
  const data = await response.json().catch();
  if (!response.ok || !(data == null ? void 0 : data.results)) {
    return [];
  }
  return data.results;
}
function normalizeAccounts(accounts, profiles, session) {
  return accounts.map((account) => {
    var _a;
    return {
      id: account.id,
      name: account.is_team_account ? account.name : account.owner.name,
      hasTeams: account.is_team_account ? true : false,
      avatar: account.is_team_account ? account.logo_url : ((_a = profiles.find((profile) => profile.id === session.id)) == null ? void 0 : _a.photo_url) ?? account.logo_url
    };
  });
}
export {
  fetchAccounts,
  normalizeAccounts
};
